export default __webpack_public_path__ + "static/media/rfbin_11.8b9e8968.png";